import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetProductsQueryResponse, GetProductQueryResponse, CreateProductCommand, UpdateProductCommand } from '../../interfaces/interfaces';
import { ProductsService } from '../products.service';
import { MaintainStockComponent } from '../maintain-stock/maintain-stock.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, CancelEvent, CellClickEvent, CellCloseEvent, DataStateChangeEvent, EditEvent, GridComponent, 
  GridDataResult, RemoveEvent, SaveEvent } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ReOrderProductComponent } from '../reorder-products/reorder-product.component';
import { Keys } from '@progress/kendo-angular-common';


@Component({
  selector: 'sdc-stock-count-batch',
  templateUrl: './stock-count-batch.component.html',
  styleUrls: ['./stock-count-batch.component.scss']
})
export class StockCountBatchComponent implements OnInit {

  jewelleryForm: UntypedFormGroup;
  isLoading = false;
  canEdit = false;
  chosenJewellery: GetProductsQueryResponse;
  jewelleries = [];
  userName: string;
  role: string;

  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateProductCommand;
  public editDataItem: GetProductQueryResponse;
  public isNew: boolean;
  public jewellery: GetProductQueryResponse;
  public products: GetProductQueryResponse[] = [];
  updateProductCommand: UpdateProductCommand;
  private updatedItems: UpdateProductCommand[] = [];

  private editedRowIndex: number;
  private editedProduct: UpdateProductCommand;

  
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateAlert: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateWarning: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  //public gridData: Observable<any>;
  public gridDataAlert: Observable<any>;
  public gridDataWarning: Observable<any>;
  public gridData: any = process(this.products, this.gridState);

  public data: GetProductQueryResponse[] = [];

  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private productService: ProductsService,
  ) { }

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
    //this.role = localStorage.getitem('currentRole');
    this.intialiseData();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    //alert("In State");
    this.gridState = state;
    //this.gridData = process(this.products, this.gridState);
    this.gridData = this.productService.getAllProducts().pipe(
      map((data) => process(data.products, this.gridState))
    );
  }

  
  intialiseData(): void {

    //alert("Initialise");
    if (this.role == 'Stock')
    {
      this.gridData = this.productService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
      //this.gridData = this.productService.apiProductGet().pipe(
      //  map((data) => process(data.products.filter(x => x.store == 'DISHD'), this.gridState))
      //);
    }
    else if (this.role == 'Creams')
    {
      this.gridData = this.productService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
    }
    else {
      //this.gridData = process(this.data, this.gridState);
      this.gridData = this.productService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
    }
    
    this.productService.getAllProducts().pipe(take(1)).subscribe({
      next: (response: GetProductsQueryResponse) => {
        //alert(this.role);
        if (this.role == 'Stock')
        {
          //response.products = response.products.filter(x => x.store == 'DISHD');
        }
        this.chosenJewellery = response;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

  updateJewellery(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.jewellery = this.chosenJewellery.products.find(x => x.id === sid);
    console.log(this.jewellery);
    const dialogRef = this.dialog.open(MaintainStockComponent, {
      width: '1300px',
      data: this.jewellery,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData(); 
    });
  }

  
}
